import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { Repository } from 'src/components/pipelines/models';
import { getPipelinesPageURL } from 'src/components/pipelines/utils/links';

import BoatImage from './assets/BoatImage';
import BoatSmokeCrud1Image from './assets/BoatSmokeCrud';
import BoatSmokeCrud2Image from './assets/BoatSmokeCrud2';
import BoatSmokeEndImage from './assets/BoatSmokeEnd';
import BoatSmokeStartImage from './assets/BoatSmokeStart';
import BoatWaveImage from './assets/BoatWave';
import {
  Animation,
  Boat,
  Crud1,
  Crud2,
  SmokeEnd,
  SmokeStart,
  WaitingForDeploymentsCenter,
  WaitingForDeploymentsWrapper,
  Wave,
} from './styled';

type Props = {
  repository: Repository;
};

const WaitingForDeployment = ({ repository }: Props) => {
  const { createAnalyticsEvent } = useAnalyticsEvents();

  useEffect(() => {
    createAnalyticsEvent({
      name: 'deploymentWaitingForDeploymentScreen',
    }).fire();
  }, [createAnalyticsEvent]);

  return (
    <WaitingForDeploymentsWrapper>
      <WaitingForDeploymentsCenter>
        <Animation>
          <Boat>
            <BoatImage />
          </Boat>

          <Crud1>
            <BoatSmokeCrud1Image />
          </Crud1>

          <Crud2>
            <BoatSmokeCrud2Image />
          </Crud2>

          <SmokeStart>
            <BoatSmokeStartImage />
          </SmokeStart>

          <SmokeEnd>
            <BoatSmokeEndImage />
          </SmokeEnd>

          <Wave>
            <BoatWaveImage />
          </Wave>
        </Animation>
        <h3>Deployment tracking with Bitbucket</h3>
        <p>
          Congratulations on configuring Bitbucket Deployments! Once your
          deployment step is running, you&apos;ll see the deployment details
          here.
          <br />
          <br />
          <a href={getPipelinesPageURL(repository.path)} target="_top">
            Go to Pipelines
          </a>
        </p>
      </WaitingForDeploymentsCenter>
    </WaitingForDeploymentsWrapper>
  );
};

export default React.memo(WaitingForDeployment);
